import React from "react";
import DatePicker from "react-datepicker";
import DatePickerIcon from "../../../../shared/Svg/DatePickerIcon";

export default ({ selected, onChange }) => (
  <div className="d-flex text-dark mb-5 bold">
    Release(d) on:
    <label className="date-picker-label">
      <DatePicker
        id="datepicker"
        className="text-center mr-3"
        selected={selected}
        onChange={onChange}
        dateFormat="LLLL dd, yyyy 'AT' hh : mm a"
        showTimeSelect
      />
      <DatePickerIcon className="icon" color="#01a0c6" />
    </label>
  </div>
);
